'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../../buttons/ClearButton/ClearButton.js');
var SecondaryButton = require('../../buttons/SecondaryButton/SecondaryButton.js');
require('../../buttons/AddAttachmentsButton/AddAttachmentsButton.js');
require('../../buttons/BlueTextButton/BlueTextButton.js');
require('../../buttons/BackButton/BackButton.js');
require('../../buttons/BorderlessButton/BorderlessButton.js');
require('../../buttons/ButtonAndStatus/ButtonAndStatus.js');
require('../../buttons/ButtonGroup/ButtonGroup.js');
require('../../buttons/DialogPrimaryButton/DialogPrimaryButton.js');
require('../../buttons/DialogSecondaryButton/DialogSecondaryButton.js');
require('../../buttons/DialogWarningButton/DialogWarningButton.js');
var FormButton = require('../../buttons/FormButton/FormButton.js');
require('../../buttons/IconButtonWithDropDown/IconButtonWithDropDown.js');
require('../../buttons/PillButton/PillButton.js');
var PrimaryButton = require('../../buttons/PrimaryButton/PrimaryButton.js');
require('../../buttons/TwoToneButton/TwoToneButton.js');
require('../../buttons/WarningButton/WarningButton.js');
require('../../buttons/AvatarButtons/ButtonWithAvatar/ButtonWithAvatar.js');
require('../../buttons/AvatarButtons/AvatarWithSubtitle/AvatarWithSubtitle.js');
require('../../buttons/AvatarButtons/VerticalAvatar/VerticalAvatar.js');
var CardRow = require('../../CardRow/CardRow.js');

var ThreeButtonFooter = function (props) {
    var leftHandler = props.leftHandler, secondaryRightHandler = props.secondaryRightHandler, primaryRightHandler = props.primaryRightHandler, leftTitle = props.leftTitle, secondaryRightTitle = props.secondaryRightTitle, primaryRightTitle = props.primaryRightTitle, icon = props.icon;
    return (React__default.createElement(CardRow, { left: React__default.createElement(SecondaryButton, { icon: icon, onClick: leftHandler, title: leftTitle }), right: React__default.createElement(React__default.Fragment, null,
            React__default.createElement("span", { style: { marginRight: '10px' } },
                React__default.createElement(FormButton, { onClick: secondaryRightHandler, title: secondaryRightTitle })),
            React__default.createElement(PrimaryButton, { onClick: primaryRightHandler, title: primaryRightTitle })) }));
};

module.exports = ThreeButtonFooter;
